import { combineReducers } from "redux";
import auth from "auth/store/reducers";
import fuse from "./fuse";

const rootReducer = combineReducers({
  auth,
  fuse
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js